export default "__VITE_ASSET__a6521066__"